import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

type KpiTabToolbarRegisterContextValue = {
  setToolbar: (node: React.ReactNode) => void;
};

const KpiTabToolbarRegisterContext =
  createContext<KpiTabToolbarRegisterContextValue | null>(null);

const KpiTabToolbarDisplayContext = createContext<React.ReactNode>(null);

export const KpiTabToolbarProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [toolbar, setToolbar] = useState<React.ReactNode>(null);
  const register = useMemo(
    () => ({
      setToolbar,
    }),
    [],
  );

  return (
    <KpiTabToolbarRegisterContext.Provider value={register}>
      <KpiTabToolbarDisplayContext.Provider value={toolbar}>
        {children}
      </KpiTabToolbarDisplayContext.Provider>
    </KpiTabToolbarRegisterContext.Provider>
  );
};

/** Renders date/export controls in the KPI tabs row (see KPIs.js). */
export const useKpiTabToolbar = (content: React.ReactNode): void => {
  const register = useContext(KpiTabToolbarRegisterContext);

  useEffect(() => {
    if (!register) return undefined;
    register.setToolbar(content);
    return () => register.setToolbar(null);
  }, [register, content]);
};

export const useKpiTabToolbarSlot = (): React.ReactNode =>
  useContext(KpiTabToolbarDisplayContext);
